// import StatusCancelledIcon from "@/images/status-cancelled-icon.png";
// import StatusNewIcon from "@/images/status-new-icon.png";
// import { Center, HStack, Tag, TagLabel, TagProps, Image } from "@chakra-ui/react";
import { Col, Row } from "antd";
import React, { ReactNode, MouseEvent } from "react";
import { OrderStatus } from "../types";

export type StatusTagProps = {
  icon?: ReactNode;
  iconPosition?: "left" | "right";
  description: ReactNode;
  status: OrderStatus;
  onClick?(event: MouseEvent<HTMLElement>): void;
};
const OrderStatusTag = ({
  description,
  icon,
  iconPosition = "left",
  status,
  onClick,
}: StatusTagProps) => {
  return (
    <Row justify='center' align='middle' className={`cr-status cr-${status}`} onClick={onClick}>
      <Col>
        <Row gutter={5}>
          {iconPosition === "left" && <Col>{icon}</Col>}
          <Col>{description}</Col>
          {iconPosition === "right" && <Col>{icon}</Col>}
        </Row>
      </Col>
    </Row>
  );
};
export default OrderStatusTag;
